<template>
    <div>
        <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                        text
                        v-bind="attrs"
                        v-on="on"
                        :class="buttonTextColor"
                >
                    {{ currentName }}
                </v-btn>
            </template>
            <v-list>
                <v-list-item
                        v-for="(item, index) in currencies"
                        :key="index"
                        @click="setCurrency(item.name)"
                >
                    <v-list-item-title>{{ item.name.toUpperCase() }}</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
    </div>
</template>

<script>
    export default {
        name: "CurrencySelector",
        props:['textColor'],
        computed: {
            buttonTextColor() {
                return this.textColor ||'white--text mobile-text-color';
            },
            currencies() {
                return this.$store.state.currency;
            },
            currentName() {
                return this.$store.state.appCurrency;
            }
        },
        methods: {
            setCurrency(name) {
                window.localStorage.setItem('appCurrency', name);
                window.location.reload();
            }
        }
    }
</script>

<style scoped>
    @media only screen and (max-width: 800px) {
        .white--text.mobile-text-color {
            color: #F5B821!important;
        }
    }
</style>
